import { PlusOutlined } from "@ant-design/icons";
import { Alert, Avatar, List, Row } from "antd";
import { rgba } from "polished";
import styled from "styled-components";

export const StyledConnectionListItem = styled.div`
  padding: 4px 16px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  border: 0 none !important;
  align-items: flex-start;
  color: ${({ theme }) => theme.palette.text.primary};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const StyledConnectionAvatar = styled(Avatar)`
  width: 40px;
  height: 40px;
  margin-right: 14px;

  [dir="rtl"] & {
    margin-right: 0;
    margin-left: 14px;
  }
`;

export const StyledConnectionContent = styled.div`
  position: relative;
`;
export const StyledConnectionTitle = styled.p`
  margin-bottom: 0;
  font-weight: ${({ theme }) => theme.font.weight.medium};
`;

export const StyledSidebarHeader = styled.div`
  padding: 8px;
  background-color: ${({ theme }) =>
    rgba(theme.palette.primary.main, 0.1)}!important;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding: 12px;
  }

  & .ant-btn {
    border-radius: ${({ theme }) => theme.cardRadius};
    padding: 8px 28px;
    height: 42.5px;
  }

  .collapse-btn span {
    color: ${({ theme }) => theme.palette.text.hint};
  }
`;

export const StyledSidebarScrollbar = styled.div`
  height: auto;
  overflow-x: hidden;
  border: transparent;
  display: flex;
  flex: 1;
  min-height: 250px;
`;

export const StyledSidebarContent = styled(Row)`
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  flex: 1;
  border: 1px solid ${({ theme }) => theme.palette.dividerColor};
  background-color: ${({ theme }) => theme.palette.background.default};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding-bottom: 20px;
  }
`;

export const StyledSidebarList = styled(List)`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 8px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}px) {
    margin-bottom: 20px;
  }
`;

export const StyledSidebarTitle = styled.h5`
  font-size: ${({ theme }) => theme.font.size.base};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  margin-top: 16px;
  padding-left: 16px;
  padding-right: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}px) {
    margin-top: 20px;
  }
`;

export const StyledLabelItem = styled.div`
  position: relative;
  font-size: 15px;

  & a {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.palette.text.primary};
    padding: 8.5px 16px;
    margin-right: 20px;
    border-radius: 0 ${({ theme }) => theme.cardRadius}
      ${({ theme }) => theme.cardRadius30} 0;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      padding: 8.5px 20px;
    }

    &:hover,
    &:focus,
    &.active {
      color: ${({ theme }) => theme.palette.primary.main};
      background-color: ${({ theme }) => rgba(theme.palette.primary.main, 0.1)};
    }

    [dir="rtl"] & {
      margin-right: 0;
      margin-left: 20px;
      border-radius: ${({ theme }) => theme.cardRadius};
    }
  }

  & .mail-dots {
    margin-right: 16px;

    [dir="rtl"] & {
      margin-right: 0;
      margin-left: 16px;
    }

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.xxl}px) {
      margin-right: 20px;

      [dir="rtl"] & {
        margin-right: 0;
        margin-left: 20px;
      }
    }
  }
`;

export const StyledPlusOutlined = styled(PlusOutlined)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 16px;
`;

export const StyledSidebarFooter = styled(Alert)`
  &.ant-alert.ant-alert-info {
    transition: all 0.3s ease;
    width: 100%;
    background-color: ${({ theme }) =>
      rgba(theme.palette.primary.main, 0.1)}!important;
    color: ${({ theme }) => theme.palette.text.primary}!important;
    border: 0 none !important;
    border-radius: ${({ theme }) => theme.cardRadius};
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
`;
